import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { IssueTypesViewTopBar } from "./TopBar"

export const issueTypesViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: IssueTypesViewTopBar,
}
